import { Component, OnInit, Input, Output, EventEmitter, OnChanges, ChangeDetectionStrategy } from '@angular/core';
@Component({
    selector: 'mt-quick-filters',
    templateUrl: 'index.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class QuickFiltersComponent implements OnInit, OnChanges {
  @Input() filters?: any = [];
  // TODO: will use this variable to show applied button defaiult on refresh/reload the page
  @Input() defaultFilters: any = {};
  @Input() class?: string;
  @Output() filter = new EventEmitter<any>();

  constructor() {}

  ngOnInit() {}

  ngOnChanges() {}

  getButtonClass(event$: any) {
    const { filter } = event$;
    const { appliedGroupList } = this.defaultFilters;
    if (appliedGroupList) {
      if (filter.icon === appliedGroupList[filter.filterType]) return 'rounded';
    }
    return 'outline rounded';
  }

  // on active/clear the quick filter
  onFilter($event: any) {
    let { filter } = $event;
    const obj = { type: 'quickFilter', model: 'quick', value: filter };
    this.filter.emit(obj);
  }
}
